module.exports = __webpack_public_path__ + "static/media/Smoochum_gaussian2.e54fd736.png";